import React from 'react'

// Very simple component that receives two props:
// An image to display and isSelected to see if it's selected (styling purposes)

const Flag = ({ image, isSelected, ...props }) => (
  <img style={{height:'25px', paddingLeft:'10px'}} alt="flag" src={image} className={isSelected ? 'flag selected' : 'flag'} {...props} />
)

export default Flag